import { render, staticRenderFns } from "./ViewContractResources.vue?vue&type=template&id=01233e5d&scoped=true&"
import script from "./ViewContractResources.vue?vue&type=script&lang=js&"
export * from "./ViewContractResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01233e5d",
  null
  
)

export default component.exports